import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel, Row, Col, Input, ControlLabel, Uploader, Message } from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { isValidators, requiredFiled, isImageOrPdf } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment'
import AppContext from '../../context/AppContext'
import { useForm, Controller } from 'react-hook-form'
import { isEmpty } from 'lodash-es'
import {
  savePeriodicManagement,
  downloadPeriodManageFile,
} from '../../redux/actions/periodicManagement'
import { startLoading, doneLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import globalMsgUtil from '../../utils/globalMsgUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { getConvertDateTimeToThaiShort, getValueFromOptions } from '../../utils/dataUtil'
import InputForm from '../../components/forms/input/InputForm'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'

export default function PeriodicManagementWidget({
  schema,
  dataKeyTable,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDelete,
  expand: _expand,
  periodNo,
  periodNoText,
  periodOfLength,
  projectCode,
  ...props
}) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [tableDataFiles, setTableDataFiles] = useState([])
  const [referDateDocument, setReferDateDocument] = useState(null)
  const [finalInstallment, setFinalInstallment] = useState('NO')
  const [isLoading, setIsLoading] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isDisabled, setIsDisabled] = useState(schema.disabled)
  const [checkPeriodStatus, setCheckPeriodStatus] = useState()

  const STAUS_FINAL_INSTALLMENT = {
    YES: 'YES',
    NO: 'NO',
  }
  const defaultMaxFileSize = 5

  useEffect(() => {
    setTableData(schema.periodInfo || [])
    setCheckPeriodStatus(schema.periodStatus.value || 0)

    let data = []
    if (schema?.documentAndReport?.attachFiles?.values) {
      data = schema?.documentAndReport?.attachFiles?.values || []
    }

    if (schema?.attachFiles?.values) {
      data = [...data, ...schema?.attachFiles?.values]
    }

    setTableDataFiles(data)
  }, [schema])

  useEffect(() => {
    if (periodNo == periodOfLength) {
      setFinalInstallment(STAUS_FINAL_INSTALLMENT.YES)
    } else {
      setFinalInstallment(STAUS_FINAL_INSTALLMENT.NO)
    }
  }, [periodNo])

  const onSave = (data) => {
    const formData = new FormData()

    if (
      checkPeriodStatus != '0' &&
      checkPeriodStatus != '1' &&
      (data.file?.length == 0 || data.file?.length == undefined)
    ) {
      notification.open('error', {
        title: 'กรุณาแนบเอกสารแนบประกอบ',
        duration: 5000,
      })
      return
    }
    data.file &&
      data.file?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    formData.append('Id', schema.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodNumber', periodNo || '')
    formData.append('AmountRefund', data.amountRefund || 0)
    formData.append('WithdrawExtra', data.withdrawExtra || 0)
    formData.append('IssueDate', moment(data.issueDate).format('YYYY/MM/DD') || '')
    formData.append('IssueNote', data.issueNote || '')
    formData.append('PeriodStatus', data.periodStatus || '')

    // handleCallService(formData, projectCode, periodNo)

    setRequestBody(formData)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    try {
      var response = await savePeriodicManagement(requestBody, projectCode, periodNo)

      if (response) {
        const data = response.model
        setTableData(data.periodInfo || [])

        let datas = []
        if (schema?.documentAndReport?.attachFiles?.values) {
          datas = schema?.documentAndReport?.attachFiles?.values || []
        }

        if (schema?.attachFiles?.values) {
          datas = [...datas, ...schema?.attachFiles?.values]
        }

        setTableDataFiles(datas)

        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })
      }

      setIsShowConfirm(false)
    } catch (e) {
      let msg = ''
      if (e?.response?.data) {
        msg = e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR
      } else {
        msg = globalMsgUtil.SET_IS_ERROR
      }

      notification.open('error', {
        title: msg,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCancel = () => {
    history.push({
      pathname: pathname.incomeAndExpense.ProjectBasedItems,
    })
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)

    var file = await downloadPeriodManageFile(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()

    setIsLoading(false)
    doneLoading()
  }

  const onDownloadFCFile = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      const link = document.createElement('a')
      link.href = fileObj.url
      link.target = '_blank'
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (e) {
      // console.log('error', e)

      notification.open('error', {
        title: e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={`รายละเอียดการบันทึก ${periodNoText || 0}`}
        bordered
      >
        {isLoading && <OverlayLoader />}

        <Table wordWrap autoHeight loading={loading} data={tableData} style={{ marginTop: 10 }}>
          <Column width={80}>
            <HeaderCell>งวดที่</HeaderCell>
            <Cell dataKey="periodNo" />
          </Column>

          <Column width={250}>
            <HeaderCell>วันที่เริ่มต้น - วันที่สิ้นสุด</HeaderCell>
            <Cell dataKey="startAndEndDate" />
          </Column>

          <Column width={160}>
            <HeaderCell>จำนวนเงินงวด (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.budgetOfPeriod || 0)
              }}
            </Cell>
          </Column>

          <Column width={160}>
            <HeaderCell>จำนวนเงินจ่าย (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.amountOfPay || 0)
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>จำนวนเงินคงเหลือ (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.amountOfBalance || 0)
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>สถานะงวด</HeaderCell>
            <Cell dataKey="periodStatus" />
          </Column>

          <Column width={180}>
            <HeaderCell>ครุภัณฑ์ปิดโครงการ</HeaderCell>
            <Cell dataKey="durableArticlesProjectClose" style={{ textAlign: 'center' }} />
          </Column>
        </Table>

        <div style={{ marginTop: 15 }}>
          {schema.periodStatus && (
            <Row style={{ marginBottom: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {isDisabled ? (
                    <span>{schema.periodStatus.label}</span>
                  ) : (
                    requiredFiled(schema.periodStatus.validators, schema.periodStatus.label)
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {isDisabled ? (
                  <span>{` : ${getValueFromOptions(
                    schema.periodStatus.options,
                    schema.periodStatus.value || '1'
                  )}`}</span>
                ) : (
                  <>
                    <InputSelectForm
                      hideLabel
                      disabled={isDisabled || schema.periodStatus.disabled}
                      schema={schema.periodStatus}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      onChange={(value) => {
                        // handleChangePeriodStatus(value)
                        setCheckPeriodStatus(value)
                      }}
                    />
                  </>
                )}
              </Col>
              <Col lg={10} md={10} sm={24} xs={24}></Col>
            </Row>
          )}
          {schema.issueDate && (
            <>
              <Row style={{ marginBottom: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {isDisabled ? (
                      <span>{schema.issueNote.label}</span>
                    ) : (
                      requiredFiled(schema.issueNote.validators, schema.issueDate.label)
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {isDisabled ? (
                    // <span>{schema.issueDate.value}</span>
                    <span>{` : ${getConvertDateTimeToThaiShort(schema.issueDate.value)}`}</span>
                  ) : (
                    <>
                      <ErrorMessage
                        error={errors[schema.issueDate.name]}
                        style={{ marginBottom: 10 }}
                      />
                      <Controller
                        key={schema.issueDate.name}
                        name={schema.issueDate.name}
                        control={control}
                        defaultValue={
                          schema.issueDate.value
                            ? moment(
                                moment(schema.issueDate.value).format('DD/MM/YYYY'),
                                'DD/MM/YYYY'
                              ).toDate()
                            : null
                        }
                        rules={isValidators(schema.issueDate.validators)}
                        render={(props) => {
                          return (
                            <DatePickerCustom
                              {...props}
                              onChange={(value) => {
                                props.onChange(value)
                                setReferDateDocument(value)
                              }}
                            />
                          )
                        }}
                      />
                    </>
                  )}
                </Col>
                <Col lg={10} md={10} sm={24} xs={24}></Col>
              </Row>
              <Row style={{ marginBottom: 30 }}>
                <Col lg={6} md={6} sm={24} xs={24}></Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <div
                    style={{ color: 'red', fontSize: '0.8rem', fontWeight: 'bold' }}
                    dangerouslySetInnerHTML={{
                      __html:
                        finalInstallment != STAUS_FINAL_INSTALLMENT.YES
                          ? schema.description
                          : schema.description2,
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
          {schema.issueNote && (
            <Row style={{ marginBottom: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {isDisabled ? (
                    <span>{schema.issueNote.label}</span>
                  ) : (
                    requiredFiled(schema.issueNote.validators, schema.issueNote.label)
                  )}
                </ControlLabel>
              </Col>
              <Col lg={18} md={18} sm={24} xs={24}>
                {isDisabled ? (
                  // <span>{schema.issueNote.value}</span>
                  <span>{` : ${schema.issueNote.value || ''}`}</span>
                ) : (
                  <InputForm
                    hideLabel
                    disabled={isDisabled || schema.issueNote.disabled}
                    schema={schema.issueNote}
                    rows={4}
                    componentClass="textarea"
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                )}
              </Col>
              {/* <Col lg={8} md={8} sm={24} xs={24}></Col> */}
            </Row>
          )}

          {schema.attachFiles && (
            <Row style={{ marginBottom: 10 }}>
              {!isDisabled && (
                <>
                  <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    {checkPeriodStatus != '0' && checkPeriodStatus != '1' ? (
                      <ControlLabel>
                        {requiredFiled(schema.attachFiles.validators, schema.attachFiles.label)}
                      </ControlLabel>
                    ) : (
                      <ControlLabel>{schema.attachFiles.label}</ControlLabel>
                    )}
                  </Col>
                  <Col lg={18} md={18} sm={24} xs={24}>
                    <Controller
                      name={'file'}
                      control={control}
                      defaultValue={undefined}
                      render={(props) => {
                        return (
                          <Uploader
                            accept={schema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                            draggable
                            autoUpload={false}
                            multiple={true}
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]

                                if (
                                  file.blobFile.size >
                                  (schema?.attachFiles?.fileSize || defaultMaxFileSize) *
                                    1024 *
                                    1024
                                ) {
                                  notification.open('error', {
                                    title: `ขนาดไฟล์เกิน ${
                                      schema.attachFiles.fileSize || defaultMaxFileSize
                                    } MB`,
                                    duration: 5000,
                                  })
                                  return
                                }

                                if (isImageOrPdf(file.blobFile.type)) {
                                  props.onChange(fileList)
                                  //setFileTypeError(false)
                                } else {
                                  //setFileTypeError(true)
                                  notification.open('error', {
                                    title:
                                      'ชนิดที่รองรับ ' + schema.attachFiles.fileType ||
                                      '.jpg, .jpeg, .png, .pdf',
                                    duration: 5000,
                                  })
                                }
                              }
                            }}
                          >
                            <div>
                              <Icon size="2x" icon="upload2" />
                              <small className="uploder__text"></small>
                              {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                schema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                              } 
                          , ขนาดไฟล์ไม่เกิน ${
                            schema.attachFiles.fileSize || defaultMaxFileSize
                          } MB`}
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}></Col>
                </>
              )}
            </Row>
          )}

          {finalInstallment == STAUS_FINAL_INSTALLMENT.YES && (
            <Row style={{ marginBottom: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {/* {requiredFiled(schema.amountRefund.validators, schema.amountRefund.label)} */}
                  {isDisabled ? (
                    <span>{schema.amountRefund.label}</span>
                  ) : (
                    requiredFiled(schema.amountRefund.validators, schema.amountRefund.label)
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {isDisabled ? (
                  <span>{` : ${budgetFormat(schema.amountRefund.value)}`}</span>
                ) : (
                  <>
                    <ErrorMessage
                      error={errors[schema.amountRefund.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <Input
                      placeholder={schema.amountRefund.hint}
                      defaultValue={schema.amountRefund.value}
                      name={schema.amountRefund.name}
                      inputRef={register(isValidators(schema.amountRefund.validators))}
                      type="number"
                    />
                  </>
                )}
              </Col>
              <Col lg={10} md={10} sm={24} xs={24}></Col>
            </Row>
          )}
          {finalInstallment == STAUS_FINAL_INSTALLMENT.YES && (
            <Row style={{ marginBottom: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {/* {requiredFiled(schema.withdrawExtra.validators, schema.withdrawExtra.label)} */}
                  {isDisabled ? (
                    <span>{schema.withdrawExtra.label}</span>
                  ) : (
                    requiredFiled(schema.withdrawExtra.validators, schema.withdrawExtra.label)
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {isDisabled ? (
                  <span>{` : ${budgetFormat(schema.withdrawExtra.value)}`}</span>
                ) : (
                  <>
                    <ErrorMessage
                      error={errors[schema.withdrawExtra.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <Input
                      placeholder={schema.withdrawExtra.hint}
                      defaultValue={schema.withdrawExtra.value}
                      name={schema.withdrawExtra.name}
                      inputRef={register(isValidators(schema.withdrawExtra.validators))}
                      type="number"
                    />
                  </>
                )}
              </Col>
              <Col lg={10} md={10} sm={24} xs={24}></Col>
            </Row>
          )}

          {schema?.message && (
            <Message
              showIcon
              type={schema.message.type}
              description={`${schema.message.message}`}
              style={{ marginBottom: 10 }}
            />
          )}

          {!isDisabled && (
            <Row style={{ marginBottom: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'center' }}>
                <SaveButton
                  disabled={false}
                  onClick={handleSubmit(onSave)}
                  // onClick={onSave}
                  style={{ marginTop: 0, marginLeft: 20 }}
                >
                  บันทึก
                </SaveButton>

                <CancelButton
                  disabled={false}
                  style={{ marginTop: 0, marginLeft: 20 }}
                  onClick={handleCancel}
                >
                  ยกเลิก
                </CancelButton>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}></Col>
            </Row>
          )}
        </div>

        <div>
          <Table
            wordWrap
            autoHeight
            loading={loading}
            data={tableDataFiles}
            style={{ marginTop: 10 }}
          >
            <Column width={80} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column flexGrow={1}>
              <HeaderCell>รายการเอกสารและรายงาน</HeaderCell>
              <Cell dataKey="label" />
            </Column>

            <Column width={150} align="center" fixed="right">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <DownloadButton
                        // icon="download"
                        onClick={(e) => {
                          if (rowData.url) {
                            onDownloadFCFile(rowData)
                          } else {
                            onDownload(rowData)
                          }
                        }}
                      />
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />
    </>
  )
}
